import I18n from 'i18n-js'
import React from 'react'
import FontAwesome from 'react-fontawesome'
import userApi from 'services/userApi'
import constants from '../../../utils/constants'
import AutocompletionWithoutListing from './AutocompletionWithoutListing'

const SupervisorsList = ({ type, items, handleChange, editMode, deactivated }) => {
  const handleItemChange = (updatedItems) => {
    handleChange('supervisors', updatedItems)
  }

  const removeItem = (itemToRemove) => {
    handleItemChange(items.filter((item) => item !== itemToRemove))
  }

  const addItem = (itemToAdd) => {
    handleItemChange([...items, itemToAdd])
  }

  const getSuggestionsAsync = (value) => {
    return userApi
      .getUsersList({
        searchValue: value,
        type,
        role: constants.ROLES.MANAGER,
      })
      .then((response) => {
        const filteredResponse = response.filter((item) => !items.find((i) => i.id === item.id))
        return filteredResponse
      })
  }

  return (
    <div>
      {items.length > 0 ? (
        items.map((item) =>
          editMode ? (
            <div key={item.id} className="configuration container d-flex justify-content-between align-items-center">
              <span className="category-subtitle">
                {item.firstname} {item.lastname}
              </span>
              <div className="d-flex">
                <div className="action-button small" onClick={() => removeItem(item)}>
                  <FontAwesome name="trash" />
                </div>
              </div>
            </div>
          ) : (
            <div key={item.id} className="category-subtitle">
              {item.firstname} {item.lastname}
            </div>
          ),
        )
      ) : (
        <p style={{ color: deactivated ? '' : type === 'agencies' ? 'blue' : 'red' }}>{I18n.t('UserConfigurationNosupervisors')}</p>
      )}
      {editMode && (
        <AutocompletionWithoutListing toShow="fullname" onSelect={addItem} keepSelection={false} getSuggestionsAsync={getSuggestionsAsync} />
      )}
    </div>
  )
}

export default SupervisorsList
